import * as types from './mutation-types';
import {
  defaultGeneralInformationState,
  defaultPaymentsState,
  defaultReceiverState,
  defaultServicesState,
  defaultTaxesState,
} from './state';

export default {
  [types.SET_FISCAL_VALIDATION](state, payload) {
    state.fiscalValidation = payload;
  },
  [types.SET_NATURE_OF_OPERATION](state, payload) {
    state.nfse.generalInformation.natureOfOperation = payload;
  },
  [types.RESET_NFSE](state) {
    state.nfse.id = null;
    state.nfse.generalInformation = defaultGeneralInformationState();
    state.nfse.receiver = defaultReceiverState();
    state.nfse.services = defaultServicesState();
    state.nfse.taxes = defaultTaxesState();
    state.nfse.payments = defaultPaymentsState();
  },
  [types.SET_SUMMARY_NFSES](state, payload) {
    state.summaryNfses = payload;
    state.tableKey += 1;
  },
  [types.SET_PAGINATION_NFSE](state, payload) {
    state.paginationNfse = payload;
  },
  [types.SET_DETAILED_NFSE](state, payload) {
    state.nfse = payload;
  },
  [types.SET_NFSE_WARNINGS](state, payload) {
    state.warningsNfse = payload;
  },
  [types.SET_SERVICE_IN_COLLECTION](state, payload) {
    state.nfse.services.serviceCollection = payload;
  },
  [types.UPDATE_SERVICE_IN_COLLECTION](state, payload) {
    state.nfse.services.serviceCollection = payload;
  },
  [types.SET_REMAINDER](state, payload) {
    state.nfse.payments.remainder = payload;
  },
  [types.SET_CALCULATED_NFSE](state, payload) {
    state.nfse.services = {
      ...state.nfse.services,
      ...payload.services,
    };
    state.nfse.taxes = {
      ...state.nfse.taxes,
      ...payload.taxes,
    };
  },
  [types.SET_TAXES_CONFIGURATIONS](state, payload) {
    state.nfse.taxes = {
      ...state.nfse.taxes,
      ...payload,
    };
  },
  [types.SET_EMISSION_CONFIGURATIONS](state, payload) {
    if (payload.issExibility) {
      state.nfse.taxes.issExibility = payload.issExibility;
    }

    state.nfse.generalInformation.culturalEncouraging = payload.culturalEncouraging;
    state.nfse.generalInformation.serie = payload.serie;
    state.nfse.generalInformation.production = payload.production;
    state.nfse.services.nbs = payload.cityServiceListItem;
    state.nfse.services.cityTaxCode = payload.cityTaxCode;
    state.nfse.taxes.taxRegime = payload.taxRegime;
  },
  [types.SET_DETAILED_NFSE](state, payload) {
    state.nfse.id = payload.id;
    state.nfse.status = payload.status;
    state.nfse.generalInformation = {
      ...state.nfse.generalInformation,
      ...payload.generalInformation,
    };
    state.nfse.receiver = {
      ...state.nfse.receiver,
      ...payload.receiver,
    };
    state.nfse.services = {
      ...state.nfse.services,
      ...payload.services,
    };
    state.nfse.taxes = {
      ...state.nfse.taxes,
      ...payload.taxes,
    };
    state.nfse.payments = {
      ...state.nfse.payments,
      ...payload.payments,
    };
  },
};
